<div class="top_action_bar">
  <div class="search-container">
    <app-autocomplete-dropdown
      id="search-bar"
      class="autocomplete-dropdown"
      [placeholder]="'Search And Add Charges'"
      [apiUrl]="'v1/charges/list'"
      [filterByKeys]="['NAME_CONTAINS']"
      [limit]="10"
      [orderBy]="{'name': 'asc'}"
      [bindLabel]="'name'"
      [bindValue]="'id'"
      [displayColumns]="[
    {key: 'name', header: 'Charge Name'},
    {key: 'code', header: 'Code'}
    ]"
      [additionalFilters]="[
                {
                  'name': 'ACTIVE_EQUALS',
                  'alias': 'ACTIVE_EQUALS',
                  'value': ['true']
                },
                {
                  'name': 'CHARGE_ID_NOT_IN',
                  'alias': 'CHARGE_ID_NOT_IN',
                  'value': preSelectedRowsIds.size > 0 ? Array.from(preSelectedRowsIds) : ['']
                }
              ]"
      (suggestionSelected)="handleSuggestionSelected($event)"
      [(ngModel)]="searchAndAddText"
    >
    </app-autocomplete-dropdown>
    <button type="button"
            class="add-button tertiary_button"
            [ngClass]="{ disabled: disableAddBtn }"
            (click)="addNewChargesToChargeGroup()"
            [disabled]="disableAddBtn">
      <app-svg-icon class="image-icon" [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
      <span>Add</span>
    </button>
  </div>
  @if (selectedItems.length > 0) {
    <div class="action_btns">
      <button class="secondary_button" (click)="handleBulkDelete()">Delete</button>
    </div>
  }
</div>

<app-static-table
  [(data)]="chargesAlreadyInChargeGroup"
  [tableMeta]="tableMeta"
  [showCheckBox]="true"
  (dataDeleted)="handleDataDeletion($event)"
  [(selectedItems)]="selectedItems"
>
</app-static-table>
